// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-M":"M_shp2-detail-M__EHoFq"};